import { render, staticRenderFns } from "./CreatePostMinimizedView.vue?vue&type=template&id=36893f5a&scoped=true&"
import script from "./CreatePostMinimizedView.vue?vue&type=script&lang=ts&"
export * from "./CreatePostMinimizedView.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePostMinimizedView.vue?vue&type=style&index=0&id=36893f5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36893f5a",
  null
  
)

export default component.exports